import { tKey } from 'ember-intl';

/**
 * The threshold for a relative change to be considered significant.
 * Decided on 0.03 in https://otainsight.atlassian.net/browse/TOR-112
 */
export const SIGNIFICANT_RELATIVE_CHANGE_THRESHOLD = 0.03;

export const VIEWS = {
  DEPARTMENTS: 'departments',
  STRATEGY: 'strategy',
} as const;

export type View = (typeof VIEWS)[keyof typeof VIEWS];

export const ALLOWED_REFERENCE_PERIODS = ['STLY', 'SDLY', 'PP', 'custom'];

export const MAX_NUMBER_OF_REFERENCE_PERIODS = 4;

export const REFERENCE_PERIOD_TRANSLATIONS_SHORT = {
  STLY: tKey('general.reference_period.stly.short'),
  SDLY: tKey('general.reference_period.sdly.short'),
  PP: tKey('general.reference_period.previous_period'),
  custom: tKey('general.reference_period.custom'),
};

export const METRICS = {
  TOTAL_REVENUE: 'totalRevenueOrPAR',
  ROOM_REVENUE: 'totalRoomRevenueOrPAR',
  NON_ROOM_REVENUE: 'totalNonRoomRevenueOrPAR',
  NON_ROOM_PREMIUM: 'nonRoomPremium',
} as const;
export type Metric = (typeof METRICS)[keyof typeof METRICS];

export const METRIC_TRANSLATIONS = {
  [METRICS.TOTAL_REVENUE]: tKey('total_revenue.total_revenue'),
  [METRICS.ROOM_REVENUE]: tKey('total_revenue.room_revenue'),
  [METRICS.NON_ROOM_REVENUE]: tKey('total_revenue.non_room_revenue'),
  [METRICS.NON_ROOM_PREMIUM]: tKey('total_revenue.non_room_premium'),
} as const;

export const METRIC_PAR_TRANSLATIONS = {
  [METRICS.TOTAL_REVENUE]: tKey('general.trevpar'),
  [METRICS.ROOM_REVENUE]: tKey('general.revpar'),
  [METRICS.NON_ROOM_REVENUE]: tKey('general.arevpar'),
  [METRICS.NON_ROOM_PREMIUM]: tKey('total_revenue.non_room_premium'),
} as const;

export const PRODUCTION_TYPES = {
  SEGMENT: 'segment',
} as const;

export const PRODUCTION_TYPE_TRANSLATIONS = {
  [PRODUCTION_TYPES.SEGMENT]: tKey('total_revenue.production_type.segment'),
} as const;

export const CLASSIFICATIONS = {
  NURTURE: 'nurture',
  UPSELL: 'upsell',
  MARKET: 'market',
  RECONSIDER: 'reconsider',
} as const;
export type Classification =
  (typeof CLASSIFICATIONS)[keyof typeof CLASSIFICATIONS];

export const CLASSIFICATION_TRANSLATIONS = {
  [CLASSIFICATIONS.NURTURE]: tKey('total_revenue.classification.nurture'),
  [CLASSIFICATIONS.UPSELL]: tKey('total_revenue.classification.upsell'),
  [CLASSIFICATIONS.MARKET]: tKey('total_revenue.classification.market'),
  [CLASSIFICATIONS.RECONSIDER]: tKey('total_revenue.classification.reconsider'),
} as const;
